import z from 'zod';
export const pageFailedWebhookSchema = z.looseObject({
    type: z.literal('page-failed'),
    projectId: z.string(),
    documentIds: z.array(z.string()),
    pageId: z.string(),
    correlationId: z.string().optional(),
    errorCode: z.string(),
    errorMessage: z.string(),
});
//# sourceMappingURL=page-failed.webhook.js.map